<p class="title">Telegram</p>
<p class="body">{{ entity.companyDetail || '---' }}</p>
<div class="container-date">
    <p class="title-date">Fecha de actualización</p>
    <div class="item">
        <app-date displayStyle='plain' [date]="entity?.evaluation?.evaluationFinishedAt">
        </app-date>
    </div>
</div>